export default __webpack_public_path__ + "static/media/login-bg.1d61f632.svg";